import React, { Component, PropTypes } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

import './usersList.scss';

import usersStore from 'storeState/users';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import ATable from "views/aTable/ATable";
import Button from "views/button/Button";
import Loading from "views/loading/Loading";

import {formatDateTime} from 'service/LocaleService';
import _ from "lodash";
import URLService from "../../../service/URLService";

export class UsersList extends Component {

  static contextTypes = {
    intl: PropTypes.object
  }

  componentDidMount() {
    this.tenant_id = this.props.tenant_id;
    this.props.actions.usersListRequest({tenant_id: this.props.tenant_id});
  }

  componentWillReceiveProps = (nextProps) => {
    if(this.tenant_id != nextProps.tenant_id) {
      this.tenant_id = nextProps.tenant_id;
      this.props.actions.usersListRequest({tenant_id: nextProps.tenant_id});
    }
  }

  onUserClick = (user_id) => {
    if(this.props.onUserSelect) {
      this.props.onUserSelect(user_id);
    }
  }

  render() {
    return (
      <div className={`users-list`}>
        <Loading finished={this.props.users != null} render={(() =>
          <ATable>
            <tbody>
            <tr>
              <th><FormattedMessage id="usersList.username" defaultMessage="Username" /></th>
              <th><FormattedMessage id="usersList.created_at" defaultMessage="Created at" /></th>
            </tr>
            <For each="user" of={this.props.users}>
              <tr className={`clickable ${user.id === URLService.getQueryParameterAsString("user_id") ? 'selected': ''}`} onClick={() => this.onUserClick(user.id)}>
                <td>{user.username}</td>
                <td>{formatDateTime(user.created_at)}</td>
              </tr>
            </For>
            <If condition={_.size(this.props.users) === 0}>
              <tr>
                <td colSpan={2}><FormattedMessage id="usersList.empty.message" defaultMessage="No Users" /></td>
              </tr>
            </If>
            </tbody>
          </ATable>
        ).bind(this)} />
      </div>
    );
  }
}


export default connect((state, props) => {
  return {
    users: usersStore.selectors.usersList(state)
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, usersStore.actions), dispatch)
  }
})(UsersList)



// WEBPACK FOOTER //
// ./src/components/views/usersList/UsersList.js